// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fc-theme-standrard td,
.fc-theme-standard th,
.fc-theme-standard thead,
.fc-col-header,
.fc-scrollgrid,
.fc-scrollgrid td {
  border-color: rgba(204, 204, 220, 0.3) !important;
}

.fc-header-toolbar {
  height: 56px;
  margin-bottom: 0 !important;
}

.fc-toolbar-chunk {
  position: absolute;
  top: 8px;
  left: 0px;
}

.fc-toolbar-chunk button:nth-child(2) {
  text-transform: capitalize;
}

.fc-toolbar-chunk .fc-toolbar-title {
  position: absolute;
  left: 190px;
  width: 300px;
  font-size: 18px !important;
  padding-top: 4px;
}

.fc-button {
  background-color: rgba(204, 204, 220, 0.16) !important;
  padding: 4px 16px !important;
  font-size: 14px !important;
  font-weight: normal !important;
  border-radius: 2px !important;
  border: none !important;
  color: #aaaaaa !important;
}

.fc-button span {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #aaaaaa;
}

.fc-button:hover {
  background-color: rgba(204, 204, 220, 0.36) !important;
  cursor: pointer;
}

.fc-direction-ltr .fc-toolbar > * > :not(:first-child) {
  margin-left: 4px;
}

.fc-day-today {
  background: none !important;
}

.fc-day-today .fc-daygrid-day-top a {
  width: 30px;
  height: 30px;
  line-height: 24px;
  text-align: center;
  border-radius: 25px;
  background-color: #c65210;
  color: #ffffff;
}

.fc-daygrid-day-number {
  margin: 4px auto;
}

.fc-event-title {
  padding-left: 5px !important;
}
`, "",{"version":3,"sources":["webpack://./projects/Forecasting/Tabs/Holidays/View/month-view-calendar.css"],"names":[],"mappings":"AAAA;;;;;;EAME,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;EACtD,4BAA4B;EAC5B,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,sDAAsD;EACtD,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".fc-theme-standrard td,\n.fc-theme-standard th,\n.fc-theme-standard thead,\n.fc-col-header,\n.fc-scrollgrid,\n.fc-scrollgrid td {\n  border-color: rgba(204, 204, 220, 0.3) !important;\n}\n\n.fc-header-toolbar {\n  height: 56px;\n  margin-bottom: 0 !important;\n}\n\n.fc-toolbar-chunk {\n  position: absolute;\n  top: 8px;\n  left: 0px;\n}\n\n.fc-toolbar-chunk button:nth-child(2) {\n  text-transform: capitalize;\n}\n\n.fc-toolbar-chunk .fc-toolbar-title {\n  position: absolute;\n  left: 190px;\n  width: 300px;\n  font-size: 18px !important;\n  padding-top: 4px;\n}\n\n.fc-button {\n  background-color: rgba(204, 204, 220, 0.16) !important;\n  padding: 4px 16px !important;\n  font-size: 14px !important;\n  font-weight: normal !important;\n  border-radius: 2px !important;\n  border: none !important;\n  color: #aaaaaa !important;\n}\n\n.fc-button span {\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  color: #aaaaaa;\n}\n\n.fc-button:hover {\n  background-color: rgba(204, 204, 220, 0.36) !important;\n  cursor: pointer;\n}\n\n.fc-direction-ltr .fc-toolbar > * > :not(:first-child) {\n  margin-left: 4px;\n}\n\n.fc-day-today {\n  background: none !important;\n}\n\n.fc-day-today .fc-daygrid-day-top a {\n  width: 30px;\n  height: 30px;\n  line-height: 24px;\n  text-align: center;\n  border-radius: 25px;\n  background-color: #c65210;\n  color: #ffffff;\n}\n\n.fc-daygrid-day-number {\n  margin: 4px auto;\n}\n\n.fc-event-title {\n  padding-left: 5px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
